export const CATEGORIZE_STEP = 'categorize';
export const STEP_FORM_SELECT_WIDTH = 760;
export const STEP_FORM_WIDTH = 900;
export const WRITE_STEP = 'write';